import React, { Component } from 'react';
import { Steps } from 'antd';

const { Step } = Steps;
class Process extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getLocation = (activities, currentActivity) => {
    let location = -1;
    activities.forEach((item, index) => {
      if (item.uuid === currentActivity.uuid) {
        location = index;
      }
    });
    return location;
  };

  render() {
    const { instance } = this.props;
    const { status } = instance;
    const activities = instance.activities || [];
    const currentActivity = instance.currentActivity || {};
    let location = this.getLocation(activities, currentActivity);
    if (status === 1) {
      location = activities.length + 1;
    }
    return (
      <div>
        <Steps size="small" current={location}>
          {activities.map(item => (
            <Step title={item.name} key={item.uuid} description={item.processorName} />
          ))}
          <Step title="流程结束" key="over" />
        </Steps>
      </div>
    );
  }
}

export default Process;



// WEBPACK FOOTER //
// ./src/components/comm/workflow/Process.js